import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf9e88e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "editPost",
  tabindex: "-1",
  "aria-labelledby": "editPost",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title text-center fw-bold w-100",
  id: "staticBackdropLabel"
}
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "fw-bold col-form-label me-2" }
const _hoisted_11 = { class: "text-danger fs-7" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "fw-bold col-form-label me-2" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = { class: "text-danger fs-7" }
const _hoisted_20 = { class: "position-relative mb-2" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "text-danger fs-7"
}
const _hoisted_25 = { class: "mb-0 fw-bold fs-7" }
const _hoisted_26 = {
  key: 1,
  class: "mb-0 fw-bold fs-7 text-danger"
}
const _hoisted_27 = {
  key: 2,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_28 = {
  key: 3,
  class: "d-flex mb-3 justify-content-center m-2"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 4,
  class: "d-flex"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_34 = { class: "me-1 text-truncate" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 5,
  class: "d-flex justify-content-center m-2"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["src"]
const _hoisted_42 = {
  key: 2,
  class: "me-1 text-truncate"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 6,
  class: "invalid-error mar-bot-15"
}
const _hoisted_46 = {
  key: 1,
  class: "invalid-error mar-bot-15"
}
const _hoisted_47 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = { class: "fw-bold col-form-label me-2" }
const _hoisted_50 = { class: "mt-2 d-flex align-items-center justify-content-between" }
const _hoisted_51 = { class: "d-flex align-items-center" }
const _hoisted_52 = { class: "fw-bold col-form-label me-2" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 2,
  class: "invalid-error"
}
const _hoisted_55 = {
  key: 3,
  class: "text-danger fs-7"
}
const _hoisted_56 = {
  key: 4,
  class: "invalid-feedback d-block"
}
const _hoisted_57 = {
  key: 5,
  class: "invalid-feedback d-block"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-bold fs-7" }, " ※文字の入力を確定するとタグとして追加されます。 ", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-bold fs-7" }, " ※タグは1つの投稿に5つまで設定できます。 ", -1))
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-lg-6 d-lg-flex d-none justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_62 = { class: "col-lg-6 d-flex mb-lg-0 mb-4 justify-content-lg-start justify-content-center" }
const _hoisted_63 = { class: "col-lg-6 d-flex d-lg-none justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_64 = {
  class: "modal fade",
  id: "editPostDone",
  tabindex: "-1",
  "aria-labelledby": "editPostDone",
  "aria-hidden": "true"
}
const _hoisted_65 = { class: "modal-dialog" }
const _hoisted_66 = { class: "modal-content" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end p-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_68 = { class: "modal-body text-center" }
const _hoisted_69 = { class: "mb-4 d-flex justify-content-center" }

import HashTag from '@/components/hash-tag/index.vue'
import Button from '@/components/button/index.vue'
import ArticleGroup from './ArticleGroup.vue'
import { computed, ref, watch, onMounted, watchEffect, nextTick } from 'vue'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required, maxLength, minLength } from '@vuelidate/validators'
import { DEFAULT_MIN_LENGTH, MAX_UPLOAD_FILE_SIZE_MB, MAX_UPLOAD_FILE_SIZE_BYTES, MAX_LENGTH_POST_CONTENT } from '@/constants/number'
import { addPostParams } from '@/use/usePath'
import PostType from '@/views/user/community/home/index.vue'

import { cloneDeep, omit, debounce, uniqBy } from 'lodash'
import { useStore } from 'vuex'
import { POST_STORE } from '@/store/constants'
import { buildFormData, buildImgUrl, countCharInSurrogatePair, customMaxLength, customMinLength, handleBlurInput, scrollToErrors } from '@/utils'
import { imgTypes } from '@/constants/upload-type'
import { REGEX_EMOJI } from '@/constants/regex'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'
import { postMessageByCode } from '@/constants/messageCode.ts'
import UrlInput from '@/components/post-url/UrlInput.vue'
import { validateUrlRulesSF10, VALIDATOR_CONTAIN_NG_WORD } from '@/constants/validate'

type TAG = { id: number; name: string }


export default /*#__PURE__*/_defineComponent({
  props: {
  post: {
    type: Object as PostType,
  },
},
  setup(__props) {

const props = __props



const modalEdit = ref()
const modalNotification = ref()
const store = useStore()
const inputRef = ref<HTMLElement | null>(null)

const uploadImgStatus = ref<boolean>(false)
const file = ref(null)
const fileData = ref(null)
const fileUrl = ref(null)
const fileName = ref<string>(null)
const fileType = ref<string>(null)
const MaxUploadFileSize = ref(false)
const showModal = computed(() => store.getters[POST_STORE.GETTERS.POSTS]?.showModal)

const ngWords = ref({
  ngTitle: false,
  ngContent: false,
  ngTag: false,
})

/**
 * Combine with existed validation from v$ rules
 * update value after field blurred.
 */
const $externalResults = ref()

const isCheckedNGWord = { title: false, content: false, tag: false }
const MAX_LENGTH_TITLE = 30
const MAX_LENGTH_TEXT = MAX_LENGTH_POST_CONTENT
const loading = ref<boolean>(false)

onMounted(() => {
  modalEdit.value = new Modal(document.getElementById('editPost'))
})
onMounted(() => {
  modalNotification.value = new Modal(document.getElementById('editPostDone'))
})
const tags = ref<Array<any>>(cloneDeep(props.post?.tags) ?? [])
const formData = ref({
  ...cloneDeep(props.post),
  file: '',
})
const edit_post_status = computed(() => store.getters[POST_STORE.GETTERS.EDIT_POST_STATUS])

// 2022/09/21 CW-TrungNT Fix for UAT#4415: SF10 (Ph2-R20220922)
const postFailedMessageCode = computed(() => store.getters[POST_STORE.GETTERS.POST_FAILED_MESSAGE_CODE])
const emojiTag = ref<boolean>(false)
const duplicateTags = ref<boolean>(false)

const errorUpload = ref(false)
watch(
  () => props.post,
  () => {
    tags.value = cloneDeep(props.post?.tags)
    formData.value = {
      ...cloneDeep(props.post),
      file: '',
    }
    deleteTags.value = []
  },
  { deep: true }
)

const tag = ref<Pick<TAG, 'name'>>('')

const deleteTags = ref<Array<any>>([])

const checkTags = ref<boolean>(false)
const checkNgTags = async (): Promise<void> => {
  if (tags.value.length === 0) {
    checkTags.value = false
    emojiTag.value = false
    return
  }
  const tagData = tags.value.map((e: TAG) => e.name).join(', ')
  try {
    // REGEX_EMOJIは絵文字を含まない場合にTrueとなるので反転する
    emojiTag.value = !REGEX_EMOJI.test(tagData)
    if (!emojiTag.value) {
      const data = await commonService.sendNGWordCheck({ sentence: tagData })
      checkTags.value = data.data.data.has_ngword
    }
  } catch (error) {
    console.log(error)
  }
}

const createTag = async (): Promise<void> => {
  // 2022/11/14 TienNV Fix bug post list  UAT#5117: SF10(Ph2-R20221116)
  if (!tag.value || tags.value?.length === 5) return
  isCheckedNGWord.tag = false
  await checkNGKeyTag(tag.value)
  while (!isCheckedNGWord.tag) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (emojiTag.value) return
  if (ngWords.value.ngTag) return

  const trimmedArray = tag.value.replace(/\s+/g, ' ').split(' ')
  trimmedArray.forEach((elem: string) => {
    for (let i = 0; i < elem.length; i = i + 20) {
      if (tags.value?.length === 5) break
      let trimmedString = elem.substring(i, i + 20)

      tags.value.push({
        id: `new-${Date.now()}${tags.value?.length}`,
        name: trimmedString,
      })
    }
  })
  tag.value = ''

  if (tags.value?.length < 5) {
    inputRef.value?.focus()
  }
}

const removeTag = async (id: number): Promise<void> => {
  tags.value = tags.value.filter((e: TAG) => e.id !== id)
  let removeTag = formData.value?.tags.find((e) => e.id === id)
  if (formData.value?.tags.length > 0 && removeTag) {
    deleteTags.value.push({
      ...removeTag,
      _destroy: 1,
    })
  }
  await checkNgTags()
}

const editTag = async (id: number, name: string): Promise<void> => {
  inputRef.value?.focus()
  const trimmedArray = name.replace(/\s+/g, ' ').split(' ')
  trimmedArray.forEach((elem: string, index: number) => {
    for (let i = 0; i < elem.length; i = i + 20) {
      if ((index || (!index && i)) && tags.value?.length === 5) break
      let trimmedString = elem.substring(i, i + 20)

      if (!index && !i) {
        tags.value = tags.value.map((e: TAG) => ({
          ...e,
          name: e.id === id ? trimmedString : e.name,
        }))
      } else {
        tags.value.push({
          id: `new-${Date.now()}${tags.value?.length}`,
          name: trimmedString,
        })
      }
    }
  })
  await checkNgTags()
}

const rules = computed(() => {
  return {
    title: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_TITLE),
      minLength: minLength(DEFAULT_MIN_LENGTH),
    },
    // 2022/12/01 TienNV Fix for UAT#5347: CT10 (Ph2-R20221222)
    content: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_TEXT),
      minLength: (value: string) => customMinLength(value, DEFAULT_MIN_LENGTH),
    },
    site_name_1: {},
    site_url_1: {},
    site_name_2: {},
    site_url_2: {},
    ...validateUrlRulesSF10('site_name_1', 'site_url_1', formData),
    ...validateUrlRulesSF10('site_name_2', 'site_url_2', formData),
  }
})

const length_content = ref(0)
const textCounter = (maxLength: number, currentLength: number): number => {
  return maxLength - currentLength
}

const removeAvatar = (): void => {
  formData.value.file = null
  file.value = null
  fileData.value = null
  fileUrl.value = null
  fileName.value = null
  fileType.value = null
}

const removeCurrentFile = (type: 'file' | 'image' = 'image'): void => {
  formData.value[`${type}_url`] = null
  // removeAvatar()
}

const handleChangeFile = async () => {
  uploadImgStatus.value = true
  if (file.value.files[0]) {
    const { newFileUrl, newFile } = await buildImgUrl(file.value?.files[0])
    uploadImgStatus.value = false

    fileUrl.value = newFileUrl

    fileData.value = newFile

    fileType.value = newFile?.type
    fileName.value = newFile?.name
    formData.value.file = file.value.files[0]
  }
  uploadImgStatus.value = false
  removeCurrentFile('file')
}

watch(
  () => fileType.value,
  () => {
    if (fileType.value == null || ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(fileType.value)) {
      if (formData.value.content && formData.value.title) v$.value.$invalid = false
      errorUpload.value = false
    } else {
      v$.value.$invalid = true
      errorUpload.value = true
    }
  }
)

watch(
  () => formData.value?.file,
  () => {
    if (formData.value?.file && formData.value?.file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      MaxUploadFileSize.value = true
    } else {
      MaxUploadFileSize.value = false
    }
  }
)

// 2022/09/21 CW-TrungNT Fix for UAT#4415: SF10 (Ph2-R20220922)
watch(
  () => tags.value,
  () => {
    // 2022/11/14 TienNV Fix bug post list  UAT#5117: SF10(Ph2-R20221116)
    if (uniqBy(tags.value, 'name')?.length !== tags.value?.length) {
      duplicateTags.value = true
    } else {
      duplicateTags.value = false
    }
  },
  { immediate: true, deep: true }
)

const v$ = useVuelidate(rules, formData, { $externalResults })

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  loading.value = true

  isCheckedNGWord.title = false
  isCheckedNGWord.content = false
  await checkNGKeyTitle()
  await checkNGKeyContent()
  if (formData.value.site_name_1) await validateUrlNgWord('site_name_1')
  if (formData.value.site_name_2) await validateUrlNgWord('site_name_2')
  while (!isCheckedNGWord.title || !isCheckedNGWord.content) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (
    v$.value.$invalid ||
    ngWords.value.ngTitle ||
    ngWords.value.ngTag ||
    ngWords.value.ngContent ||
    MaxUploadFileSize.value ||
    errorUpload.value ||
    checkTags.value ||
    emojiTag.value ||
    duplicateTags.value
  ) {
    loading.value = false
    nextTick(() => {
      const elementErrors = document.querySelector('#editPost .invalid-feedback')
      const classErrors = elementErrors ? '.invalid-feedback' : '.invalid-error'
      scrollToErrors(classErrors, '#editPost')
    })
    return
  }

  const tagRemoveId = tags.value.map((e) => (e.id.startsWith('new') ? omit(e, 'id') : e))

  const updatePostJson = {
    ...omit(formData.value, 'image_url', 'file_url', 'file'),

    tags: [...tagRemoveId, ...deleteTags.value],
  }

  const updatePost = new FormData()
  buildFormData(updatePost, updatePostJson)
  if (fileData.value) {
    updatePost.append(imgTypes.includes(fileType.value) ? 'image' : 'file', fileData.value)
    ;['image_url', 'file_url'].forEach((e) => {
      updatePost.append(e, '')
    })
  } else {
    ;['image_url', 'file_url'].forEach((e) => {
      if (!formData.value[e]) {
        updatePost.append(e, '')
      } else {
        updatePost.append(e, formData.value[e])
      }
    })
  }

  await store.dispatch(POST_STORE.ACTIONS.UPDATE_POST, updatePost)
  loading.value = false
  if (showModal.value) {
    modalNotification.value?.show()
  }

  modalEdit.value?.hide()
  resetForm()
}

const resetForm = (): void => {
  v$.value.$reset()
  file.value = null
  fileUrl.value = null
  fileName.value = null
  fileType.value = null
  fileData.value = null
  tag.value = ''
  ngWords.value = { ngTitle: false, ngContent: false, ngTag: false }
  emojiTag.value = false
  checkTags.value = false
}

const checkNGKeyTitle = debounce(async () => {
  const queryData = { sentence: formData.value.title }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWords.value.ngTitle = data.data.data.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGWord.title = true
  }
})

const checkNGKeyContent = debounce(async () => {
  const queryData = { sentence: formData.value.content }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWords.value.ngContent = data.data.data.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGWord.content = true
  }
})

const checkNGKeyTag = debounce(async (value: string) => {
  if (!value || tags.value.length === 5) {
    emojiTag.value = false
    ngWords.value.ngTag = false
    isCheckedNGWord.tag = true
    return
  }
  const queryData = { sentence: value }
  try {
    // REGEX_EMOJIは絵文字を含まない場合にTrueとなるので反転する
    emojiTag.value = !REGEX_EMOJI.test(value)
    if (!emojiTag.value) {
      const data = await commonService.sendNGWordCheck(queryData)
      ngWords.value.ngTag = data.data.data.has_ngword
    } else {
      ngWords.value.ngTag = false
    }
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGWord.tag = true
  }
})

watch(
  () => tag.value,
  (newVal: any) => {
    checkNGKeyTag(newVal as string)
  }
)

const BackForm = () => {
  formData.value = cloneDeep(props.post)
  tags.value = cloneDeep(props.post?.tags)
  resetForm()
}
onMounted(() => {
  window.addEventListener('hidden.bs.modal', function () {
    BackForm()
  })
})

const focusInputTag = () => {
  if (tags.value.length === 5) return

  inputRef.value?.focus()
}

const validateUrlNgWord = async (name: string) => {
  const queryData = { sentence: formData.value[name] }
  const data = await commonService.sendNGWordCheck(queryData)
  const { has_ngword: isNotValid } = data.data.data

  $externalResults.value = { ...$externalResults.value, [name]: isNotValid ? [VALIDATOR_CONTAIN_NG_WORD] : [] }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('createPost')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: BackForm
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _withModifiers(onSubmit, ["prevent"]),
            class: "modal-body p-3 pb-4 pb-lg-5 w-100 mx-lg-auto mx-1"
          }, [
            _createVNode(ArticleGroup, {
              showType: __props.post?.content_type
            }, null, 8, ["showType"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(translate)(`title`)), 1),
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(textCounter(MAX_LENGTH_TITLE, _unref(countCharInSurrogatePair)(formData.value?.title))), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "title",
                class: _normalizeClass(['form-control mb-2', _unref(v$).title.$error || ngWords.value.ngTitle ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).title.$model) = $event)),
                placeholder: _unref(translate)('SD10requireTitle'),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(checkNGKeyTitle)()))
              }, null, 42, _hoisted_12), [
                [
                  _vModelText,
                  _unref(v$).title.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngWords.value.ngTitle && !_unref(v$).title.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)(`title`),
                validator: _unref(v$).title.$errors[0]?.$validator,
                params: [_unref(DEFAULT_MIN_LENGTH), MAX_LENGTH_TITLE]
              }, null, 8, ["title", "validator", "params"]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(translate)(`content`)), 1),
                    _hoisted_18,
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(textCounter(_unref(MAX_LENGTH_TEXT), _unref(countCharInSurrogatePair)(formData.value?.content))), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "content",
                    rows: "5",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                    onBlur: _cache[3] || (_cache[3] = () => (_unref(v$).content.$model = _unref(v$).content.$model.replace(/\n+$/, ''))),
                    class: _normalizeClass(['form-control ', _unref(v$).content.$error || ngWords.value.ngContent ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('SD10requireText'),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_unref(checkNGKeyContent)()))
                  }, null, 42, _hoisted_21), [
                    [_vModelText, _unref(v$).content.$model]
                  ]),
                  _createElementVNode("label", {
                    class: _normalizeClass(['camera position-absolute cursor-pointer', _unref(v$).content.$error ? 'camera--err' : '']),
                    for: "imgEdit"
                  }, _hoisted_23, 2),
                  _createElementVNode("input", {
                    type: "file",
                    class: "d-none",
                    id: "imgEdit",
                    accept: "image/png, image/jpeg, image/jpg, application/pdf",
                    ref: (_value, _refs) => {
                      _refs['file'] = _value
                      file.value = _value
                    },
                    onChange: handleChangeFile,
                    onClick: _cache[5] || (_cache[5] = 
                    (event) => {
                      event.target.value = null
                    }
                  )
                  }, null, 544),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)(`content`),
                    validator: _unref(v$).content.$errors[0]?.$validator,
                    params: [_unref(DEFAULT_MIN_LENGTH), _unref(MAX_LENGTH_TEXT)]
                  }, null, 8, ["title", "validator", "params"])
                ]),
                (ngWords.value.ngContent && !_unref(v$).content.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(translate)('postImageAnnotation1')), 1),
                (__props.post?.content_type === 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, "※「興味あり」を押してくれた人とチャットができるようになります。"))
                  : _createCommentVNode("", true),
                (uploadImgStatus.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                  : _createCommentVNode("", true),
                (formData.value?.image_url && !fileName.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("img", {
                        src: __props.post.image_url ? _unref(addPostParams)(__props.post.image_url, __props.post?.content_type) : undefined,
                        alt: "image",
                        class: "me-1 object-fit-contain mw-100"
                      }, null, 8, _hoisted_29),
                      _createElementVNode("div", {
                        class: "close-icon cursor-pointer",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (removeCurrentFile()))
                      }, _hoisted_31)
                    ]))
                  : _createCommentVNode("", true),
                (formData.value?.file_url)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, _toDisplayString(__props.post.file_url.split('/').slice(-1)[0]), 1),
                      _createElementVNode("div", {
                        class: "close-icon cursor-pointer",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (removeCurrentFile('file')))
                      }, _hoisted_36)
                    ]))
                  : _createCommentVNode("", true),
                (fileName.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      (!fileType.value.includes('image'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                        : _createCommentVNode("", true),
                      (fileType.value.includes('image'))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: fileUrl.value ? _unref(addPostParams)(fileUrl.value, __props.post?.content_type) : undefined,
                            alt: "image",
                            class: "me-2 object-fit-contain mw-100"
                          }, null, 8, _hoisted_41))
                        : (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(fileName.value), 1)),
                      _createElementVNode("div", {
                        class: "close-icon cursor-pointer",
                        onClick: removeAvatar
                      }, _hoisted_44)
                    ]))
                  : _createCommentVNode("", true),
                (MaxUploadFileSize.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(translate)('validateFileSize', '', [_unref(MAX_UPLOAD_FILE_SIZE_MB)])), 1))
                  : _createCommentVNode("", true)
              ]),
              (errorUpload.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_unref(translate)('errorFileUpload')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(translate)(`CT10url`)), 1)
                ])
              ]),
              _createVNode(UrlInput, {
                "site-name-id": "site_name_1",
                "site-url-id": "site_url_1",
                "on-field-blur": validateUrlNgWord,
                "site-url": _unref(v$).site_url_1,
                "site-name": _unref(v$).site_name_1,
                "site-name-label": _unref(translate)('CT10siteName1'),
                "site-url-label": _unref(translate)('CT10siteUrl1'),
                "site-url-validate-msg": _unref(translate)('required1')
              }, null, 8, ["site-url", "site-name", "site-name-label", "site-url-label", "site-url-validate-msg"]),
              _createVNode(UrlInput, {
                class: "mt-4",
                "site-name-id": "site_name_2",
                "site-url-id": "site_url_2",
                "on-field-blur": validateUrlNgWord,
                "site-url": _unref(v$).site_url_2,
                "site-name": _unref(v$).site_name_2,
                "site-name-label": _unref(translate)('CT10siteName2'),
                "site-url-label": _unref(translate)('CT10siteUrl2'),
                "site-url-validate-msg": _unref(translate)('required1')
              }, null, 8, ["site-url", "site-name", "site-name-label", "site-url-label", "site-url-validate-msg"]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(translate)(`CT10tag`)), 1)
                ])
              ]),
              _createElementVNode("label", {
                class: "d-flex flex-wrap form-control mb-2",
                onClick: _withModifiers(focusInputTag, ["self"])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                  return (_openBlock(), _createBlock(HashTag, {
                    tag: tag,
                    key: tag.id,
                    class: "me-2 mb-2",
                    removeTag: () => removeTag(tag.id),
                    onEditTag: editTag,
                    editable: true
                  }, null, 8, ["tag", "removeTag"]))
                }), 128)),
                (tags.value?.length < 5)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      ref: (_value, _refs) => {
                        _refs['inputRef'] = _value
                        inputRef.value = _value
                      },
                      type: "text",
                      class: "border-0 input-tag",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((tag).value = $event)),
                      onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => ($event.target.blur()), ["enter"])),
                      onInput: _cache[10] || (_cache[10] = (eve) => _unref(handleBlurInput)(eve, inputRef.value)),
                      onBlur: createTag
                    }, null, 544)), [
                      [
                        _vModelText,
                        tag.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ], 8, _hoisted_53),
              (emojiTag.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_unref(translate)('validateEmoji')), 1))
                : (ngWords.value.ngTag || checkTags.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : (duplicateTags.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_unref(translate)('VALIDATE_SAME_TAGS')), 1))
                    : _createCommentVNode("", true),
              (tags.value?.length > 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, " ※タグは1つの投稿に5つまで設定できます。 "))
                : _createCommentVNode("", true),
              _hoisted_58,
              _hoisted_59
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  class: "m-w-unset fw-bold",
                  onClick: BackForm,
                  type: 'secondary',
                  "data-bs-dismiss": 'modal'
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(Button, {
                  onClick: onSubmit,
                  title: _unref(translate)('postSubmit'),
                  class: "m-w-unset",
                  type: 'primary',
                  loading: loading.value,
                  disabled: 
                  _unref(v$).$invalid || emojiTag.value || checkTags.value || ngWords.value.ngTitle || ngWords.value.ngTag || ngWords.value.ngContent || MaxUploadFileSize.value || loading.value || errorUpload.value || duplicateTags.value
                
                }, null, 8, ["title", "loading", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  class: "m-w-unset fw-bold",
                  type: 'secondary',
                  "data-bs-dismiss": 'modal'
                }, null, 8, ["title"])
              ])
            ])
          ], 40, _hoisted_6)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_64, [
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, _toDisplayString(_unref(edit_post_status) ? _unref(postMessageByCode)(_unref(postFailedMessageCode)) || _unref(translate)('CC41updateFailed') : _unref(translate)('updateComplete')), 1),
          _createElementVNode("div", _hoisted_69, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": 'modal'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})